"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const PodioBadRequestError_1 = __importDefault(require("../exceptions/PodioBadRequestError"));
const PodioForbiddenError_1 = __importDefault(require("../exceptions/PodioForbiddenError"));
const PodioError_1 = __importDefault(require("../exceptions/PodioError"));
const PodioAuthorizationError_1 = __importDefault(require("../exceptions/PodioAuthorizationError"));
const PodioConflictError_1 = __importDefault(require("../exceptions/PodioConflictError"));
const PodioGoneError_1 = __importDefault(require("../exceptions/PodioGoneError"));
const PodioRateLimitError_1 = __importDefault(require("../exceptions/PodioRateLimitError"));
const PodioServerError_1 = __importDefault(require("../exceptions/PodioServerError"));
const PodioUnavailableError_1 = __importDefault(require("../exceptions/PodioUnavailableError"));
class PodioErrorFactory {
    static getError(statusCode) {
        var _a;
        return (_a = this.classMappings[statusCode]) !== null && _a !== void 0 ? _a : PodioError_1.default;
    }
}
exports.default = PodioErrorFactory;
/**
 * Error class mappings
 *
 */
PodioErrorFactory.classMappings = {
    400: PodioBadRequestError_1.default,
    401: PodioAuthorizationError_1.default,
    403: PodioForbiddenError_1.default,
    404: PodioForbiddenError_1.default,
    409: PodioConflictError_1.default,
    410: PodioGoneError_1.default,
    420: PodioRateLimitError_1.default,
    500: PodioServerError_1.default,
    502: PodioUnavailableError_1.default,
    503: PodioUnavailableError_1.default,
    504: PodioUnavailableError_1.default,
};
